import { FeatureFlagsList } from '@features/feature-flags-list';
import { Drawer } from '@latitude/drawer';
import { Text } from '@latitude/text';
import { useCallback, useState } from 'react';

import ToggleButton from './ToggleButton';

const DevToolsDrawer = () => {
  const [isOpen, setIsOpen] = useState(false);

  // Only show in non-production environments
  const shouldShow =
    typeof window !== 'undefined' &&
    window?.env?.SENTRY_ENVIRONMENT !== 'production';

  const toggleDrawer = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  if (!shouldShow) {
    return null;
  }

  return (
    <>
      <ToggleButton onClick={toggleDrawer} />
      <Drawer
        open={isOpen}
        onOpenChange={() => setIsOpen(false)}
        size="small"
        title={<Text variant="headingMedium">Dev Tools</Text>}
      >
        <FeatureFlagsList />
      </Drawer>
    </>
  );
};

export default DevToolsDrawer;
